<span>Assitance for {{assistanceId}}</span>

<table class="table table-striped table-condensed table-secondary small">
    
    <tr *ngFor="let field of $any(task) | keyvalue">
        <th>{{field.key}}</th>
        <td>{{field.value}}</td>
    </tr>

    <!-- <tr *ngFor="let field of pointTest | keyvalue">
        <th>{{field.key}}</th>
        <td>{{field.value}}</td>
    </tr> -->
    
</table>

